export type ClasseSpecie = "ceduo-latifoglie" |
    "ceduo-castagno" |
    "fustaia-abete-bianco" |
    "fustaia-larice" |
    "fustaia-pino-domestico" |
    "fustaia-pino-marittimo" |
    "fustaia-pino-nero" |
    "fustaia-pino-aleppo" |
    "fustaia-pino-silvestre" |
    "ceduo-querce" |
    "fustaia-querce" |
    "ceduo-faggio" |
    "fustaia-faggio" |
    "fustaia-abete-rosso" |
    "ceduo-eucalitti" |
    "fustaia-eucalitti" |
    "ceduo-pioppi" |
    "fustaia-pioppi";

export const classiValenzaDenrologicaPerSpecie: { codice: string, soglia: number, classeSuperiore: ClasseSpecie, classeInferiore?: ClasseSpecie }[] = [
    {
        codice: "Aa",
        soglia: 0,
        classeSuperiore: "fustaia-abete-bianco",
        classeInferiore: null
    },
    {
        codice: "Ace",
        soglia: 0,
        classeSuperiore: "fustaia-abete-bianco",
        classeInferiore: null
    },
    {
        codice: "An",
        soglia: 0,
        classeSuperiore: "fustaia-abete-bianco",
        classeInferiore: null
    },
    {
        codice: "Abi",
        soglia: 0,
        classeSuperiore: "fustaia-abete-bianco",
        classeInferiore: null
    },
    {
        codice: "Aca",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Alo",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Am",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ane",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ao",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Apl",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ap",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ah",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Aal",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Aco",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ag",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ai",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Au",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Bp",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Bpu",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Bet",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Bpa",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cb",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Co",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cs",
        soglia: 27,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-castagno"
    },
    {
        codice: "Cbi",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cat",
        soglia: 0,
        classeSuperiore: "fustaia-larice",
        classeInferiore: null
    },
    {
        codice: "Cd",
        soglia: 0,
        classeSuperiore: "fustaia-larice",
        classeInferiore: null
    },
    {
        codice: "Cl",
        soglia: 0,
        classeSuperiore: "fustaia-larice",
        classeInferiore: null
    },
    {
        codice: "Ced",
        soglia: 0,
        classeSuperiore: "fustaia-larice",
        classeInferiore: null
    },
    {
        codice: "Cel",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cer",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ces",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Chl",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Cc",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cma",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Csa",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cav",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cmo",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cox",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cra",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Cj",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Cua",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Cum",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Cus",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Ea",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Eu",
        soglia: 27,
        classeSuperiore: "fustaia-eucalitti",
        classeInferiore: "ceduo-eucalitti"
    },
    {
        codice: "Fs",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-faggio"
    },
    {
        codice: "Fc",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Fe",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Fo",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Fa",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Gen",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ia",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Jn",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Jr",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ld",
        soglia: 0,
        classeSuperiore: "fustaia-larice",
        classeInferiore: null
    },
    {
        codice: "Lk",
        soglia: 0,
        classeSuperiore: "fustaia-larice",
        classeInferiore: null
    },
    {
        codice: "Ln",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Lt",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Mp",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Mal",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Mg",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ma",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Mn",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Mor",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Mc",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "No",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Oe",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Oc",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Phl",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pha",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pa",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Pic",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Pb",
        soglia: 0,
        classeSuperiore: "fustaia-pino-aleppo",
        classeInferiore: null
    },
    {
        codice: "Pca",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pc",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Ph",
        soglia: 0,
        classeSuperiore: "fustaia-pino-aleppo",
        classeInferiore: null
    },
    {
        codice: "Pnl",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Ple",
        soglia: 0,
        classeSuperiore: "fustaia-pino-aleppo",
        classeInferiore: null
    },
    {
        codice: "Pm",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pna",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pp",
        soglia: 0,
        classeSuperiore: "fustaia-pino-marittimo",
        classeInferiore: null
    },
    {
        codice: "Ppi",
        soglia: 0,
        classeSuperiore: "fustaia-pino-domestico",
        classeInferiore: null
    },
    {
        codice: "Pra",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pin",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pst",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Ps",
        soglia: 0,
        classeSuperiore: "fustaia-pino-silvestre",
        classeInferiore: null
    },
    {
        codice: "Pu",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pw",
        soglia: 0,
        classeSuperiore: "fustaia-pino-nero",
        classeInferiore: null
    },
    {
        codice: "Pil",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pit",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Plh",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Plo",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pl",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pal",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Pcn",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Pn",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Pni",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Pop",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Pt",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Peu",
        soglia: 12,
        classeSuperiore: "fustaia-pioppi",
        classeInferiore: "ceduo-pioppi"
    },
    {
        codice: "Pav",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pd",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ppa",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Prs",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pru",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Pme",
        soglia: 0,
        classeSuperiore: "fustaia-abete-bianco",
        classeInferiore: null
    },
    {
        codice: "Pgr",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Py",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Qc",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qco",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qcr",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qda",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qfa",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qf",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qi",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qma",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qpe",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qpu",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qpd",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qro",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qr",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Que",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qs",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qtr",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Qvi",
        soglia: 22,
        classeSuperiore: "fustaia-querce",
        classeInferiore: "ceduo-querce"
    },
    {
        codice: "Ra",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Rp",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sal",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sc",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sa",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sra",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ss",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sse",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Sar",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sau",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sd",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Sor",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "St",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "T",
        soglia: 17,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Tb",
        soglia: 0,
        classeSuperiore: "fustaia-abete-bianco",
        classeInferiore: null
    },
    {
        codice: "Th",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Tic",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Tip",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ti",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ts",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Ug",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Um",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Ul",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Con",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Cx",
        soglia: 0,
        classeSuperiore: "fustaia-abete-rosso",
        classeInferiore: null
    },
    {
        codice: "Lat",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    },
    {
        codice: "Lx",
        soglia: 22,
        classeSuperiore: "fustaia-faggio",
        classeInferiore: "ceduo-latifoglie"
    }
]